import React from 'react';
const Mannual = (props) => {
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("circle", { cx: "6.5", cy: "6.5", r: "6.5", transform: "matrix(1 0 0 -1 1.63281 14.5)", stroke: "#C9CBD6" }),
        React.createElement("path", { d: "M8.13281 11.3V7", stroke: "#C9CBD6", "stroke-linecap": "round" }),
        React.createElement("path", { d: "M8.7332 4.9C8.7332 4.56863 8.46457 4.3 8.1332 4.3C7.80183 4.3 7.5332 4.56863 7.5332 4.9C7.5332 5.23137 7.80183 5.5 8.1332 5.5C8.46457 5.5 8.7332 5.23137 8.7332 4.9Z", fill: "#C9CBD6" })));
};
export default Mannual;
